import { render } from "./DashboardSelector.vue?vue&type=template&id=797c794e"
import script from "./DashboardSelector.vue?vue&type=script&lang=js"
export * from "./DashboardSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__